import React from 'react'
import Loading from '../Loading'

const ConsultRequsetButton = ({ onClick, title, subTitle, price, showIcon, btnText, subDescPrice }) => {
  const formatMoney = (price) => {
    return (parseInt(price)).toLocaleString("fa-IR", { minimumFractionDigits: 0 })
  }

  const priceLabelClass = () => {
    let className = 'quick-request__price '
    if (subDescPrice) className += 'sub-desc-price'
    return className
  }

  return (
    <div className="card" style={{ padding: 0, overflow: 'hidden', minHeight: 104 }}>
      <div className="quick-request" onClick={onClick} style={showIcon && { paddingRight: '.5rem' }}>
        {showIcon &&
          <div className="icon">
            <span className="icon1"></span>
            <span className="icon2"></span>
            <span className="icon3"></span>
          </div>
        }
        <div className="quick-request__content">
          <div className="title">{title}</div>
          <div className="sub-title">{subTitle}</div>
        </div>
        <div className="quick-request__info-box">
          {!price ? <Loading style={{ margin: 'auto', background: 'rgba(255, 255, 255, 0)', display: 'flex', alignItems: 'center', width: 25, height: 40 }} /> :
            <div className={priceLabelClass()}>تومان {formatMoney(price)}
              {subDescPrice && <div style={{ fontSize: 9 }}>{subDescPrice}</div>}
            </div>}
          <button className="quick-request__btn">{btnText}</button>
        </div>
      </div>
    </div>
  )
}

export default ConsultRequsetButton